import naja from 'naja'

// Redirect je nutné řešit javascriptově. Bez tohoto by nefungovalo: $this->presenter->redirect(...)
naja.redirectHandler.addEventListener('redirect', (e) => {
    window.location.href = e.detail.url
})